
const isLogin=()=>{
    const token = localStorage.getItem('token');
    return token?true:false
}
module.exports={
    isLogin:isLogin
}